import { atom } from 'jotai';

import { ContentCardItem } from '@/lib/types/content';

export const contentsAtom = atom<{ currentPage: number; cardItems: ContentCardItem[] }>({ currentPage: 1, cardItems: [] });
